export default "__VITE_ASSET__70537125__$_?component__"